/**
 * @generated SignedSource<<4f3c2166ec278b097813cabf6e3516f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionAnswerListItem_User$data = {
  readonly configuration: {
    readonly videoMaxDuration: number | null | undefined;
    readonly videoMinDuration: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_User">;
  readonly " $fragmentType": "QuestionAnswerListItem_User";
};
export type QuestionAnswerListItem_User$key = {
  readonly " $data"?: QuestionAnswerListItem_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionAnswerListItem_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionAnswerListItem_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Configuration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoMaxDuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoMinDuration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerListItem_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2271e4d81ed9a708d6ca0156fc084a40";

export default node;
